var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AnomalyDetection',_vm._b({},'AnomalyDetection',{ deviceData: _vm.deviceData, chartWidth: _vm.chartWidth },false))
}
var staticRenderFns = []

export { render, staticRenderFns }